import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'Utils/localization/i18next';
import styles from './HouseholdSection.module.scss';

const HouseholdSection = props => (
  <fieldset className={styles['household-section']}>
    {props.title && (
      <legend className={styles['household-section-title']}>
        {t(props.title)}
      </legend>
    )}
    {props.children}
  </fieldset>
);

HouseholdSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default HouseholdSection;
